import React, { useState, useEffect } from 'react';
import './styles.css';

const SlideUpWrapper = ({ children, direction = 'slide-up' }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    return (
        <div className={'slide-up-container '+ (!isVisible?'hidden':'visible '+direction)}>
            {children}
        </div>
    );
};

export default SlideUpWrapper;
